import { Mail } from "lucide-react";
import { Button } from "src/components/ui/button";

interface EmailSignInUpButtonProps {
  isLoading?: boolean;
  disabled?: boolean;
  label: string;
  onClick: () => void;
}

export const EmailSignInUpButton = ({
  isLoading = false,
  disabled = false,
  label,
  onClick,
}: EmailSignInUpButtonProps) => {
  return (
    <Button
      disabled={disabled}
      type="button"
      variant="outline"
      className={`b2b-btn justify-center w-full bg-gray-200`}
      onClick={() => !isLoading && onClick()}
    >
      <div className="flex items-center justify-center w-full">
        <Mail
          style={{ width: '24px', height: '24px' }}
        />

        <span className={`flex-1 text-center mx-4`}>
          {label}
        </span>
      </div>
    </Button>
  );
};

